<template>
    <div data-cy="view-sub-container" class="form-container">
        <div class="form-section" data-cy="section-general">
            <div class="section-body">
                <div v-if="showCompany" data-cy="field-company-name" class="input-container w-full px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.company_name') }}</ui-label>
                    <div class="subText">{{ upload_log.company_name }}</div>
                </div>
                <div data-cy="field-tp-count" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.tp_count') }}</ui-label>
                    <div class="subText">{{ upload_log.tp_count }}</div>
                </div>
                <div data-cy="field-tp-merge-count" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.tp_merge_count') }}</ui-label>
                    <div class="subText">{{ upload_log.tp_merge_count }}</div>
                </div>
                <div data-cy="field-insured-count" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.insured_count') }}</ui-label>
                    <div class="subText">{{ upload_log.insured_count }}</div>
                </div>
                <div data-cy="field-insured-merge-count" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.insured_merge_count') }}</ui-label>
                    <div class="subText">{{ upload_log.insured_merge_count }}</div>
                </div>
                <div data-cy="field-invalid-insured-count" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.invalid_insured_count') }}</ui-label>
                    <div class="subText">{{ upload_log.invalid_insured_count }}</div>
                </div>
                <div data-cy="field-invalid-tp-count" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.invalid_tp_count') }}</ui-label>
                    <div class="subText">{{ upload_log.invalid_tp_count }}</div>
                </div>

                <div data-cy="field-insured-deleted" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.insured_deleted') }}</ui-label>
                    <div class="subText">{{ upload_log.insured_deleted }}</div>
                </div>
                <div data-cy="field-processing-time" class="input-container w-1/2 px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.processing_time') }}</ui-label>
                    <div class="subText">{{ upload_log.processing_time }}</div>
                </div>
                <div data-cy="field-created-at" class="input-container w-full px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.created_date') }}</ui-label>
                    <div class="subText">{{ upload_log.created_at }}</div>
                </div>
                <div data-cy="field-file-source" class="input-container w-full px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.file_source') }}</ui-label>
                    <div class="subText">{{ upload_log.file_source }}</div>
                </div>
                <div data-cy="field-mail-error" class="input-container w-full px-4 mb-4">
                    <ui-label>{{ $t('company.upload_history.view.mail_error') }}</ui-label>
                    <div class="subText">{{ upload_log.mail_error }}</div>
                </div>
            </div>
        </div>
        <div class="drawer-footer">
            <div class="flex px-2 pt-2 w-full justify-end">
                <a-button data-cy="drawer-close-button" @click="onDrawerClose" class="btn-cancel">
                    {{ $t('company.upload_history.view.buttons.close') }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import UiLabel from '@/components/ui/Label.vue';

export default {
    components: {
        UiLabel,
    },
    computed: {
        showCompany() {
            return this.is_admin_section || this.is_association_section ? true : false;
        },
    },
    props: {
        upload_log: Object,
        is_admin_section: Boolean,
        is_association_section: Boolean,
    },
    methods: {
        onDrawerClose() {
            this.$emit('onDrawerClose');
        },
    },
};
</script>
